module.exports = __webpack_public_path__ + "static/media/home-image.3a29fc9c.png";